// extracted by mini-css-extract-plugin
module.exports = {"logContainer":"Logger_logContainer__2_OgU","logContent":"Logger_logContent__2B7ZL","logText":"Logger_logText__RmtWR"};